import React from "react";
import bytesToSize from "../utils/bytesToSize";

const FileList = ({ files, onOpenModal, onUpdateFileSettings, onDeleteFile, onClearFiles, isConverting }) => {
  const outputFormats = ["mp3", "wav", "ogg", "flac", "aac", "aiff"];
  const bitrates = [
    { value: "128k", label: "128kbps (標準)" },
    { value: "192k", label: "192kbps (高音質)" },
    { value: "320k", label: "320kbps (最高音質)" },
  ];

  return (
    <div style={{ marginTop: "20px", maxWidth: "800px", margin: "20px auto" }}>
      {files.length > 0 && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            <h3>追加されたファイル</h3>
            <button
              onClick={onClearFiles}
              style={{
                padding: "8px 12px",
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              disabled={isConverting}
            >
              一括削除
            </button>
          </div>
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {files.map((item, index) => (
              <li
                key={index}
                style={{
                  padding: "15px",
                  borderBottom: "1px solid #eee",
                  textAlign: "left",
                  backgroundColor: "#fff",
                  marginBottom: "5px",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  gap: "10px"
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ flexGrow: 1, marginRight: "10px", wordBreak: "break-word" }}>
                    <div style={{ fontWeight: "bold" }}>{item.file.name}</div>
                    <div style={{ fontSize: "0.9rem", color: "#666" }}>
                      サイズ: {bytesToSize(item.file.size)}
                    </div>
                  </div>
                  <button
                    onClick={() => onDeleteFile(index)}
                    style={{
                      padding: "8px 12px",
                      backgroundColor: "#f8d7da",
                      color: "#721c24",
                      border: "1px solid #f5c6cb",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    disabled={isConverting}
                  >
                    削除
                  </button>
                </div>
                
                <div
                  className="file-list-item-controls"
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <select
                    onChange={(e) =>
                      onUpdateFileSettings(index, { format: e.target.value })
                    }
                    value={item.settings.format}
                    style={{ padding: "8px", borderRadius: "5px" }}
                    disabled={isConverting}
                  >
                    {outputFormats.map((format) => (
                      <option key={format} value={format}>
                        {format.toUpperCase()}
                      </option>
                    ))}
                  </select>

                  <select
                    onChange={(e) =>
                      onUpdateFileSettings(index, { bitrate: e.target.value })
                    }
                    value={item.settings.bitrate}
                    style={{ padding: "8px", borderRadius: "5px" }}
                    disabled={isConverting || item.settings.format === 'wav' || item.settings.format === 'flac' || item.settings.format === 'aiff'}
                  >
                    {bitrates.map((bitrate) => (
                      <option key={bitrate.value} value={bitrate.value}>
                        {bitrate.label}
                      </option>
                    ))}
                  </select>

                  <button
                    onClick={() => onOpenModal(index)}
                    style={{
                      padding: "8px 12px",
                      backgroundColor: "#f0f0f0",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    disabled={isConverting}
                  >
                    詳細設定
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default FileList;